import React from 'react';
import { NavLink } from 'react-router-dom';
const menuitems = [
    { path: '/', title: 'Home', icon: 'home' },
    { path: '/about', title: 'About', icon: 'user' },
    { path: '/portfolio', title: 'Portfolio', icon: 'briefcase' },
    { path: '/contact', title: 'Contact', icon: 'envelope-open' },
    { path: '/blog', title: 'Blog', icon: 'comments' }
]


class Header extends React.Component {
    CloseMobileMenu = (e) => {
        this.inputElement.click();
    }
    render() {
        return (
            <header className="header" id="navbar-collapse-toggle">
                <ul className="icon-menu d-none d-lg-block">
                    {
                        Object.keys(menuitems).map((item, i) => (
                            <li className="icon-box" key={i}>
                                <NavLink exact activeClassName="active" to={ menuitems[item].path }>
                                    <i className={`fa fa-${menuitems[item].icon}`}></i>
                                    <h2>{ menuitems[item].title }</h2>
                                </NavLink>
                            </li>
                        ))
                    }
                </ul>
                <nav role="navigation" className="d-block d-lg-none">
                    <div id="menuToggle">
                        <input ref={input => this.inputElement = input} type="checkbox"/>
                        <span></span>
                        <span></span>
                        <span></span>
                        <ul className="list-unstyled" id="menu">
                            {
                                Object.keys(menuitems).map((item, j) => (
                                <li key={j}>
                                    <NavLink exact activeClassName="active" onClick={this.CloseMobileMenu} to={ menuitems[item].path }>
                                        <i className={`fa fa-${menuitems[item].icon}`}></i>
                                        <span>{ menuitems[item].title }</span>
                                    </NavLink>
                                </li>
                                ))
                            }
                        </ul>
                    </div>
                </nav>
            </header>
        )
    }
}
export default Header